/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Install_DescInputs */

const en_pc_page_install_desc = /** @type {(inputs: Pc_Page_Install_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install PhotoCraft ArtCraft in about two minutes: DMG, MSI, AppImage, deb, rpm, Flatpak or build the ArtCraft open source code with Rust, plus troubleshooting.`)
};

const zh_pc_page_install_desc = /** @type {(inputs: Pc_Page_Install_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两分钟装好 PhotoCraft ArtCraft：DMG、MSI、AppImage、deb、rpm、Flatpak，或用 Rust 编译 ArtCraft 开源代码，附常见问题排查。`)
};

/**
* | output |
* | --- |
* | "Install PhotoCraft ArtCraft in about two minutes: DMG, MSI, AppImage, deb, rpm, Flatpak or build the ArtCraft open source code with Rust, plus troubleshooting." |
*
* @param {Pc_Page_Install_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_install_desc = /** @type {((inputs?: Pc_Page_Install_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Install_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_install_desc(inputs)
	return zh_pc_page_install_desc(inputs)
});
export { pc_page_install_desc as "pc.page.install.desc" }